export const DEFAULT_CORRELATION_ID = "null";
